import React, { useState, useEffect, useCallback } from "react";
import ReviewsCarousel from "./Review";
import { useTranslation } from "react-i18next";
import googlereview from "../../assets/googlereview.png";
import axios from "../../api/axios";
import { IoStarSharp, IoStarHalfSharp, IoStarOutline } from "react-icons/io5";

export default function Contentjson() {
  const [reviews, setReviews] = useState([]);
  const [googleRating, setGoogleRating] = useState(null);
  const [reviewCount, setReviewCount] = useState(null);
  const { t } = useTranslation();

  const fetchGoogleReviews = useCallback(async () => {
    const hostname = window.location.hostname
      .replace(/^www\./, "")
      .split(".")[0];

    try {
      const res = await axios.get(`google-reviews/${hostname}`);
      // console.log("Fetching Google reviews from:", res);
      const data = res.data;
      // console.log("Google reviews data:", data);
      if (!data || !data.reviews) return;

      const formatted = data.reviews.map((r, i) => ({
        id: i,
        title: r.author_name,
        comment: r.text,
        rating: r.rating,
        guestName: r.author_name,
        date: new Date(r.time * 1000).toLocaleDateString(),
      }));

      setReviews(formatted);
      setGoogleRating(data.rating || null);
      setReviewCount(data.reviewCount || null);
    } catch (err) {
      console.error("Failed to fetch Google reviews", err);
    }
  }, []);

  const renderStars = (rating) => {
    if (!rating) return "★★★★★";

    const stars = [];
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      stars.push(<IoStarSharp key={`full-${i}`} color="#FFD700" />);
    }
    if (halfStar) {
      stars.push(<IoStarHalfSharp key="half" color="#FFD700" />);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<IoStarOutline key={`empty-${i}`} color="#FFD700" />);
    }

    return stars;
  };

  useEffect(() => {
    fetchGoogleReviews();
  }, [fetchGoogleReviews]);

  // Only render if there are reviews
  return reviews.length > 0 ? (
    <div className="review-main">
      <h2 style={{ marginBottom: "30px" }}>{t("home_page.reviews")}</h2>

      <div className="review-google">
        <img src={googlereview} alt="Google" />
        <div className="review-text">
          <p className="rating-title">Google Rating</p>
          <div className="rating-stars">
            <strong>{googleRating ? googleRating.toFixed(1) : "0.0"}</strong>{" "}
            {renderStars(googleRating)}
            {reviewCount !== null && (
              <span style={{ marginLeft: "8px", fontSize: "0.9em" }}>
                ({reviewCount} reviews)
              </span>
            )}
          </div>
          <p className="rating-link">See all our reviews</p>
        </div>
      </div>

      <ReviewsCarousel reviews={reviews} />
    </div>
  ) : null;
}
